import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    document.title = "Wishlist | Dressedin by Urbanz";
    API.get("/wishlist-products").then((r) => setItems(r.data)).catch(() => setItems([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10" data-testid="wishlist-page">
      <h1 className="font-display font-black text-4xl tracking-tighter mb-10">Wishlist</h1>
      {items === null ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">{Array(4).fill(0).map((_, i) => <div key={`sk-${i}`} className="aspect-[3/4] bg-ink-surface animate-pulse" />)}</div>
      ) : items.length === 0 ? (
        <div className="text-center py-24" data-testid="empty-wishlist">
          <p className="font-display text-2xl font-bold">Nothing saved yet</p>
          <p className="text-sm text-muted-foreground mt-2">Tap the heart on any product to keep it here.</p>
          <Link to="/shop" className="btn-gold inline-block px-8 py-4 mt-8 font-display font-bold text-sm uppercase tracking-[0.2em]">Browse drops</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
